import { createReducer, reducerSwitch } from 'lib/reducerUtils'
import {
  ADD_ORDERS,
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  UPDATE_CURRENT_ORDER,
} from 'actions/actionConstants'
import {
  FETCH_ORDER,
  FETCH_ORDERS_FOR_CURRENT_USER,
  FETCH_ORDER_ITEM_FLIGHT_DETAILS,
  FETCH_TOUR_ORDER_TRAVELLER_DETAILS,
  USER_LOGIN,
  USER_LOGOUT,
} from 'actions/apiActionConstants'
import { arrayToObject } from 'lib/arrayUtils'

const initialState: App.OrdersState = {
  orders: {},
  ordersFetching: {},
  tourOrdersTravellerDetails: {},
  error: undefined,
  fetching: {
    all: false,
    upcoming: false,
    upsellable: false,
  },
  ordersFetched: {
    all: false,
    upcoming: false,
    upsellable: false,
  },
  flightDetails: {},
}

const apiRequests = reducerSwitch<App.OrdersState>({
  [FETCH_ORDER]: (state, action) => ({
    ordersFetching: {
      ...state.ordersFetching,
      [action.orderId]: true,
    },
  }),
  [FETCH_ORDERS_FOR_CURRENT_USER]: (state, action) => ({
    error: undefined,
    fetching: {
      ...state.fetching,
      [action.key]: true,
    },
  }),
  [FETCH_TOUR_ORDER_TRAVELLER_DETAILS]: (state, action) => ({
    tourOrdersTravellerDetails: {
      ...state.tourOrdersTravellerDetails,
      [action.tourOrderId]: { status: 'pending' },
    },
  }),
  [FETCH_ORDER_ITEM_FLIGHT_DETAILS]: (state, action) => ({
    flightDetails: {
      ...state.flightDetails,
      [action.key]: {
        fetching: true,
      },
    },
  }),
})

const apiSuccesses = reducerSwitch<App.OrdersState>({
  [FETCH_ORDERS_FOR_CURRENT_USER]: (state, action) => ({
    fetching: {
      ...state.fetching,
      [action.key]: false,
    },
    ordersFetched: {
      ...state.ordersFetched,
      [action.key]: true,
    },
    orders: {
      ...state.orders,
      ...arrayToObject<App.Order>(action.data, order => order.id),
    },
  }),
  [FETCH_ORDER]: (state, action) => ({
    orders: {
      ...state.orders,
      [action.orderId]: action.data,
    },
    ordersFetching: {
      ...state.ordersFetching,
      [action.orderId]: false,
    },
  }),
  [FETCH_TOUR_ORDER_TRAVELLER_DETAILS]: (state, action) => ({
    tourOrdersTravellerDetails: {
      ...state.tourOrdersTravellerDetails,
      [action.tourOrderId]: {
        status: 'fetched',
        loadedAtTimeStamp: new Date().getTime(),
        travellerDetails: action.data,
      },
    },
  }),
  [USER_LOGIN]: () => initialState,
  [USER_LOGOUT]: () => initialState,
  [FETCH_ORDER_ITEM_FLIGHT_DETAILS]: (state, action) => ({
    flightDetails: {
      ...state.flightDetails,
      [action.key]: {
        flight: action.data,
        fetching: false,
      },
    },
  }),
})

const apiFailures = reducerSwitch<App.OrdersState>({
  [FETCH_ORDERS_FOR_CURRENT_USER]: (state, action) => ({
    error: action.error,
    fetching: {
      ...state.fetching,
      [action.key]: false,
    },
  }),
  [FETCH_ORDER_ITEM_FLIGHT_DETAILS]: (state, action) => ({
    flightDetails: {
      ...state.flightDetails,
      [action.key]: {
        flight: undefined,
        fetching: false,
        error: action.error,
      },
    },
  }),
  [FETCH_ORDER]: (state, action) => ({
    ordersFetching: {
      ...state.ordersFetching,
      [action.orderId]: false,
    },
  }),
})

export default createReducer<App.OrdersState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
  [UPDATE_CURRENT_ORDER]: (state, action) => ({
    orders: {
      ...state.orders,
      [action.order.id]: action.order,
    },
  }),
  [ADD_ORDERS]: (state, action) => ({
    orders: {
      ...state.orders,
      ...arrayToObject<App.Order>(action.orders, order => order.id),
    },
  }),
  [FETCH_TOUR_ORDER_TRAVELLER_DETAILS]: (state, action) => ({
    tourOrdersTravellerDetails: {
      ...state.tourOrdersTravellerDetails,
      [action.tourOrderId]: { status: 'failed', error: action.data },
    },
  }),
})
